import { render } from "./NonSelfMatchPlayer.vue?vue&type=template&id=2e139790&scoped=true"
import script from "./NonSelfMatchPlayer.vue?vue&type=script&lang=js"
export * from "./NonSelfMatchPlayer.vue?vue&type=script&lang=js"

import "./NonSelfMatchPlayer.vue?vue&type=style&index=0&id=2e139790&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e139790"]])

export default __exports__